import type { ValueOf } from '@evc/web-components';

export const INFERENCE_TYPE = {
  FLAW_DETECTION: 'FlawDetection',
  ANOMALY_DETECTION: 'AnomalyDetection',
};
export type InferenceType = ValueOf<typeof INFERENCE_TYPE>;
